import { render, staticRenderFns } from "./OurTable.vue?vue&type=template&id=63a95bbf&scoped=true&"
import script from "./OurTable.vue?vue&type=script&lang=js&"
export * from "./OurTable.vue?vue&type=script&lang=js&"
import style0 from "./OurTable.vue?vue&type=style&index=0&id=63a95bbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a95bbf",
  null
  
)

export default component.exports